import * as React from 'react';

function SvgLight(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path opacity={0.01} fill="#000" d="M0 0h16v16H0z" />
      <path
        d="M5.987 8.83C5.365 8.427 5 7.8 5 7.133 5 5.955 6.12 5 7.5 5s2.5.955 2.5 2.133C10 7.936 9.479 8.636 8.709 9c-1.233.582-1.577.572-2.722-.17z"
        fill="#FCCE01"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7.841C12 5.723 10.206 4 8 4S4 5.723 4 7.841c0 1.21.576 2.324 1.58 3.058a.572.572 0 00.78-.102.52.52 0 00-.105-.75 2.715 2.715 0 01-1.14-2.207c0-1.53 1.294-2.772 2.886-2.772 1.593 0 2.887 1.243 2.887 2.772 0 1.007-.57 1.937-1.49 2.427a.279.279 0 00-.033.021.19.19 0 01-.012.006.11.11 0 00-.02.013c-.19.137-.302.218-.318 1.642L6.19 11.33a.557.557 0 00-.667.403.534.534 0 00.419.64l3.502.768a.567.567 0 00.47-.103.528.528 0 00.21-.418v-.287c0-.718.023-1.083.04-1.262C11.307 10.364 12 9.147 12 7.841zm-2.867 6.8a.53.53 0 01-.128-.015l-3.123-.703a.556.556 0 01-.346-.239.516.516 0 01-.069-.404.557.557 0 01.67-.398l3.123.703c.299.066.485.355.414.642a.552.552 0 01-.541.413zm-.75 1.344c.043.009.085.014.128.014.258 0 .482-.17.541-.411a.533.533 0 00-.413-.643l-2.145-.488a.558.558 0 00-.67.397.516.516 0 00.068.404c.078.12.202.206.346.239l2.145.488z"
        fill="#595959"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.979 1.407c0 .31.234.564.52.564.288 0 .522-.254.522-.564V.564C8.021.254 7.787 0 7.5 0c-.287 0-.521.254-.521.564v.843zm1.426 6.028c0 .312.233.564.521.564.288 0 .521-.252.521-.564 0-1.329-.91-2.258-2.214-2.258-.288 0-.521.252-.521.564 0 .312.233.564.52.564.276 0 1.173.082 1.173 1.13zM4.099 3.494a.495.495 0 01-.737 0l-.552-.596a.598.598 0 010-.798.495.495 0 01.738 0l.551.596c.204.22.204.58 0 .798zm-1.798 4.24c.287 0 .521-.253.521-.563 0-.31-.234-.564-.521-.564h-.78c-.286 0-.521.254-.521.564 0 .31.235.564.521.564h.78zm8.6-4.24a.598.598 0 010-.798l.55-.596a.495.495 0 01.739 0 .598.598 0 010 .798l-.552.596a.495.495 0 01-.738 0zm1.798 3.113c-.287 0-.521.254-.521.564 0 .31.234.564.521.564h.78c.286 0 .52-.254.52-.564 0-.31-.234-.564-.52-.564h-.78z"
        fill="#595959"
      />
    </svg>
  );
}

export default SvgLight;
